import React from "react"
import { useLocation } from "react-router-dom"
import { useGetHourReportFormOptionsQuery } from "../api"
import { sortProjectsByCreatedAt } from "../../projects/utils/sort"

export const useHourReportFormOptions = () => {
  const { data: optionsData, ...meta } = useGetHourReportFormOptionsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  })

  const location = useLocation()
  const mainContextId = React.useMemo(() => {
    const params = new URLSearchParams(location.search)
    return params.get("mainContext") || null
  }, [location.search])

  const { projectOptions, membershipOptions } = React.useMemo(() => {
    if (!optionsData) {
      return { projectOptions: [], membershipOptions: [] }
    }

    const { projects, memberships } = optionsData

    const filteredProjectOptions = projects.filter(({ maintainerId }) => maintainerId === mainContextId)
    const filteredMembershipOptions = memberships.filter(({ orgId }) => orgId === mainContextId)
    return {
      projectOptions: sortProjectsByCreatedAt(filteredProjectOptions),
      membershipOptions: filteredMembershipOptions,
    }
  }, [mainContextId, optionsData])

  return {
    projectOptions,
    membershipOptions,
    meta,
  }
}
